import React from 'react';
import { ILongSteelOrdersState } from '../../../store/ducks/long-steel-orders/types';
import { INewLongSteelOrdersState } from '../../../store/ducks/new-long-steel-orders/types';
import {
  ICustomer,
  TMinimalDescribeICustomer
} from '../../../store/ducks/customers/types';
import SoldToView from './SoldToView';
import ShipToView from './ShipToView';
import { ECustomerTypeView } from '../../../store/ducks/user/types';
import { InvoicesState } from '../../../store/ducks/invoices/types';

interface IEmitterAndReceiverSelector {
  orderOrInvoiceState:
    | ILongSteelOrdersState
    | INewLongSteelOrdersState
    | InvoicesState;
  customerViewType: ECustomerTypeView;
  customers: TMinimalDescribeICustomer[];
  isUserAdmin: boolean;
  emitterIds: string[];
  setEmitterIds(emitterIds: string[]): void;
  receiverId?: string;
  setReceiverId?(receiverId: string): void;
  receiverIds?: string[];
  setReceiverIds?(receiverIds: string[]): void;

  showCustomerStates: boolean;
  selectedStates: string[];
  onChangeStates(states: string[]): void;
  customersPlaceholder?: string;
  statesPlaceholder?: string;
  receiversPlaceholder?: string;
  onBlurReceivers?: () => void;
  onAdminSearch?: (id: string) => void;
  showRichDisplay?: boolean;
}

const EmitterAndReceiverSelector: React.FC<IEmitterAndReceiverSelector> = ({
  orderOrInvoiceState,
  customerViewType,
  customers,
  isUserAdmin,
  selectedStates,
  onChangeStates,
  emitterIds,
  setEmitterIds,
  receiverId,
  setReceiverId,
  receiverIds,
  setReceiverIds,
  showCustomerStates,
  customersPlaceholder,
  statesPlaceholder,
  receiversPlaceholder,
  onBlurReceivers,
  onAdminSearch,
  showRichDisplay
}) => {
  return (
    <>
      {(customerViewType === ECustomerTypeView.EMITTER || isUserAdmin) && (
        <SoldToView
          orderOrInvoiceState={orderOrInvoiceState}
          isUserAdmin={isUserAdmin}
          showCustomerStates={showCustomerStates}
          selectedStates={selectedStates}
          onChangeStates={onChangeStates}
          emitterIds={emitterIds}
          setEmitterIds={setEmitterIds}
          customers={customers}
          customersPlaceholder={customersPlaceholder}
          statesPlaceholder={statesPlaceholder}
          onAdminSearch={onAdminSearch}
          showRichDisplay={showRichDisplay}
        />
      )}

      {(customerViewType === ECustomerTypeView.RECEIVER ||
        customerViewType === ECustomerTypeView.FABRICATION_RECEIVER) && (
        <ShipToView
          orderOrInvoiceState={orderOrInvoiceState}
          isUserAdmin={isUserAdmin}
          emitterIds={emitterIds}
          setEmitterIds={setEmitterIds}
          receiverId={receiverId}
          setReceiverId={setReceiverId}
          receiverIds={receiverIds}
          setReceiverIds={setReceiverIds}
          customers={customers}
          placeholder={receiversPlaceholder}
          onBlurReceivers={onBlurReceivers}
          showRichDisplay={showRichDisplay}
        />
      )}
    </>
  );
};

export default EmitterAndReceiverSelector;
